'use client'
import styled from 'styled-components'
import { useState } from 'react'
import { LoadingFrame } from '../common/Loading'
import { useRequest } from 'ahooks'
import R from '../../../utils/http/request'
import { Services } from '../../../utils/http/Services'
import Empty from '../common/Empty'
import { XImage } from '../common/XImage'
import { commonStyles } from '../../../utils/commonStyles'
import { SearchResultItem } from '../../../utils/http/Services/project'
import Link from 'next/link'

export default function SearchBox() {
  const [keyword, setKeyword] = useState('')
  const [ready, setReady] = useState(false)
  return (
    <SearchBoxWrapper onMouseOver={() => setReady(true)}>
      <Input value={keyword} onChange={(e) => setKeyword(e.target.value)} />
      <ResultList keyword={keyword} ready={ready} />
    </SearchBoxWrapper>
  )
}

const SearchBoxWrapper = styled.div`
  min-width: 200px;
  height: 44px;
  border: 1px solid #343434;
  transition: border 0.2s;
  z-index: 99;
  position: relative;
  flex: 1;
  margin-left: 8.4vw;
  max-width: 490px;
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 40px;
    height: 20px;
    width: 100%;
    background: transparent;
  }
  &:hover > div {
      height: 260px;
      opacity: 1;
      visibility: visible;
    }
  }
  &:focus-within {
    border: 1px solid #f5d802;
  }
`

const Input = styled.input.attrs({
  placeholder: 'Search by collection name',
})`
  width: 100%;
  height: 100%;
  background: transparent;
  border: none;
  outline: none;
  padding: 0 30px;
  color: #fff;
`
function ResultList(props: { keyword: string; ready: boolean }) {
  const { data, loading } = useRequest(
    R(Services.projectService.searchCollection, { query: props.keyword, limit: 50 }),
    {
      refreshDeps: [props.keyword],
      cacheKey: props.keyword + 'searchCollection',
      debounceWait: 500,
      ready: props.ready,
    }
  )
  const list = data || []
  return (
    <ResultListWrapper>
      {list.map((item) => (
        <ResultItem item={item} key={item.id} />
      ))}
      {!loading && list.length === 0 && <Empty text={'No collections found'} />}
      {loading && <LoadingFrame size={24} />}
    </ResultListWrapper>
  )
}
const ResultListWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 60px;
  opacity: 0;
  visibility: hidden;
  width: 100%;
  height: 0;
  transition: all 0.2s;
  background: #1c1c1c;
  padding: 10px 0;
  overflow: auto;
  //设置滚动条样式，轨道颜色透明，滑块宽度4px圆角，颜色#2E2E2E;
  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background-color: #2e2e2e;
  }
  &::-webkit-scrollbar-track {
    border-radius: 2px;
    background-color: transparent;
  }
`
function ResultItem(props: { item: SearchResultItem }) {
  return (
    <Link href={`/project/${props.item.id}`}>
      <ResultItemWrapper>
        <Image src={props.item.image} />
        <Info>
          <Title>{props.item.name}</Title>
          <Text>
            #{props.item.inscription_number_min} {props.item.inscription_number_max}
          </Text>
        </Info>
      </ResultItemWrapper>
    </Link>
  )
}

const ResultItemWrapper = styled.div`
  width: 100%;
  padding: 0 24px;
  height: 80px;
  ${commonStyles.flexStart};
  position: relative;
  transition: background 0.2s;
  &:hover {
    background: #343434;
  }
`

const Image = styled(XImage)`
  width: 54px;
  height: 54px;
  border-radius: 5px;
`

const Info = styled.div`
  ${commonStyles.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  margin-left: 14px;
`

const Title = styled.h4`
  font-size: 16px;
  color: #fff;
  line-height: 1em;
`

const Text = styled.p`
  font-size: 14px;
  color: #9e9e9e;
  line-height: 18px;
  margin-top: 5px;
`
